import { lazy } from "react";

export const NavbarPreview = lazy(() => import("./NavbarPreview"));
